import React from "react";
import {
  HeaderWrap,
  FirstHalf,
  SecondHalf,
  Title,
  SubTitle,
  Text,
} from "./styled";
import Button from "shared/Button";
import { colors } from "../../../styles/colors";

const Header = ({ isLogin, isCreator, becomeCreator }) => {
  return (
    <HeaderWrap>
      <FirstHalf />
      <SecondHalf>
        <Title>
          Get paid
          <br />
          <SubTitle color="grayDark">for your recipes</SubTitle>
        </Title>
        <Text>
          Publish and sell recipes and recipe collections to your fans and
          customers around the world.
        </Text>
        {isLogin && isCreator ? null : (
          <Button
            bdButton={colors.WHITE}
            color={colors.RED}
            textColor={colors.WHITE}
            text="Become Creator"
            stylType="primary"
            onClick={becomeCreator}
          />
        )}
      </SecondHalf>
    </HeaderWrap>
  );
};

export default Header;
